import React from 'react';
import { Box, Grid } from '@mui/material';
import { Operation } from '../../../../../networkRequest/operationsService';
import { OperationsIcon } from '../../../components';
import DetailLineItems from './DetailLineItems';
import OperationMenu from './OperationMenu';
import OperationStatus from './OperationStatus';
import { OPERATION_AGENCY_OFFICIAL_ROLES } from '../../../../../constants';
import { useUser } from '@hooks/useUser';

const menuPermittedRoles = [
  OPERATION_AGENCY_OFFICIAL_ROLES.COMMAND_STAFF,
  OPERATION_AGENCY_OFFICIAL_ROLES.INCIDENT_COMMANDER,
  OPERATION_AGENCY_OFFICIAL_ROLES.DEPUTY_INCIDENT_COMMANDER,
];

interface OperationDetailsProps {
  operation: Operation;
  onStatusChange: (status: Operation['status']) => Promise<void>;
}

const OperationDetails: React.FC<OperationDetailsProps> = ({ operation, onStatusChange }) => {
  const { user } = useUser();

  if (!user) return null;

  const currentOperationAgencyOfficial = operation.operation_agency_officials.find(
    ({ agency_official }) => agency_official.id === user.profile.id,
  );

  return (
    <Grid container spacing={0} sx={{
      alignItems: "flex-start"
    }}>
      <OperationsIcon />
      <Grid size="grow" sx={{ marginLeft: '8px' }}>
        <DetailLineItems operation={operation} />
      </Grid>
      <Grid size="auto">
        <Box sx={{ width: '24px' }} />
      </Grid>

      <Grid container sx={{
        flexDirection: 'column',
        gap: 2
      }}>
        <OperationStatus status={operation.status} onChange={onStatusChange} />
        {
          currentOperationAgencyOfficial && menuPermittedRoles.includes(currentOperationAgencyOfficial?.operation_role?.name)
            ? <OperationMenu operation={operation} />
            : null
        }
      </Grid>
    </Grid>
  );
};

export default OperationDetails;